// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Spinner,
//   Button,
//   Input,
//   Form,
//   FormGroup,
//   Label,
//   Alert,
// } from "reactstrap";
// import axiosInstance from "../../Request";
// import moment from "moment";
// import { URL } from "../../api";

// const DisbursalReporting = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [filterType, setFilterType] = useState("customerId");
//   const [filterValue, setFilterValue] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   // Pagination State
//   const [page, setPage] = useState(0);
//   const [size] = useState(30);
//   const [hasNextPage, setHasNextPage] = useState(false);

//   /** * Updated Sequence:
//    * Last field: UTR
//    */
//   const manualHeaders = [
//     "customer_id",
//     "lead_id",
//     "loan_id",
//     "borrower_name",
//     "fintech_name",
//     "loan_amount",
//     "roi",
//     "tenure",
//     "processing_fee",
//     "gst",
//     "disbursal_amt",
//     "repayment_type",
//     "roi_type_value",
//     "disbursal_date",
//     "close_date",
//     "create_date",
//     "disbursal_utr" 
//   ];

//   /** Fetch Data */
//   const fetchDisbursalReport = async (pageNo = 0, isSearch = false) => {
//     setLoading(true);
//     try {
//       const filters = {};
//       if (filterValue) filters[filterType] = filterValue;
//       if (fromDate) filters.fromDate = fromDate;
//       if (toDate) filters.toDate = toDate;

//       if (!isSearch && !filterValue && !fromDate && !toDate) {
//         const today = moment().format("YYYY-MM-DD");
//         filters.fromDate = today;
//         filters.toDate = today;
//       }

//       const params = {
//         ...filters,
//         page: pageNo,
//         size: size,
//         export: false,
//       };

//       const response = await axiosInstance.get(URL.REPORTING_DISBURSAL, {
//         params,
//       });
//       const data = response.data || [];

//       setRows(data);
//       setPage(pageNo);
//       setHasNextPage(data.length === size);
//     } catch (error) {
//       console.error("Error fetching Disbursal data:", error);
//       setRows([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /** Initial Load */
//   useEffect(() => {
//     fetchDisbursalReport(0, false);
//   }, []);

//   /** Search */
//   const handleSearch = (e) => {
//     if (e) e.preventDefault();
//     fetchDisbursalReport(0, true);
//   };

//   /** Scalable CSV Export */
//   const handleExportCsv = async () => {
//     setExporting(true);
//     try {
//       const filters = {};
//       if (filterValue) filters[filterType] = filterValue;
//       if (fromDate) filters.fromDate = fromDate;
//       if (toDate) filters.toDate = toDate;

//       const response = await axiosInstance.get(URL.REPORTING_DISBURSAL, {
//         params: { ...filters, export: true },
//         responseType: "blob",
//       });

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute(
//         "download",
//         `Disbursal_Report_${moment().format("YYYY-MM-DD")}.csv`
//       );
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       alert("Export failed!");
//     } finally {
//       setExporting(false);
//     }
//   };

//   const fontStyle = { fontSize: "10px" };
//   const inputStyle = { ...fontStyle, height: "30px", padding: "2px 6px" };

//   /** Helper to format numbers to 2 decimals only if they have decimals */
//   const formatNumber = (val) => {
//     if (val === null || val === undefined || val === "") return "-";
//     if (typeof val === "number" || !isNaN(val)) {
//       const num = parseFloat(val);
//       // If it's an integer, return as is. If it has decimals, limit to 2.
//       return num % 1 === 0 ? num : num.toFixed(2);
//     }
//     return val;
//   };

//   return (
//     <div className="p-3" style={fontStyle}>
//       <Form onSubmit={handleSearch} className="mb-3">
//         <div className="d-flex flex-wrap align-items-end" style={{ gap: "10px" }}>
//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">Filter Type</Label>
//             <Input
//               type="select"
//               value={filterType}
//               onChange={(e) => setFilterType(e.target.value)}
//               style={inputStyle}
//             >
//               <option value="customerId">Customer ID</option>
//               <option value="loanId">Loan ID</option>
//               <option value="leadId">Lead ID</option>
//             </Input>
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">Filter Value</Label>
//             <Input
//               type="text"
//               value={filterValue}
//               onChange={(e) => setFilterValue(e.target.value)}
//               placeholder={`Enter ${filterType}`}
//               style={inputStyle}
//             />
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">From Date</Label>
//             <Input
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//               style={inputStyle}
//             />
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">To Date</Label>
//             <Input
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//               style={inputStyle}
//             />
//           </FormGroup>

//           <div className="d-flex" style={{ gap: "6px" }}>
//             <Button
//               color="primary"
//               type="submit"
//               disabled={loading}
//               style={{ ...fontStyle, height: "30px" }}
//             >
//               {loading ? <Spinner size="sm" /> : "Search"}
//             </Button>
//             <Button
//               color="success"
//               onClick={handleExportCsv}
//               disabled={exporting || rows.length === 0}
//               style={{ ...fontStyle, height: "30px" }}
//             >
//               {exporting ? <Spinner size="sm" /> : "Excel"}
//             </Button>
//           </div>
//         </div>
//       </Form>

//       {rows.length === 0 && !loading ? (
//         <Alert color="info">No records found for the selected criteria.</Alert>
//       ) : (
//         <>
//           <div style={{ overflowX: "auto" }}>
//             <Table bordered striped hover responsive size="sm" className="mt-2" style={fontStyle}>
//               <thead className="table-light">
//                 <tr className="text-nowrap">
//                   <th>#</th>
//                   {manualHeaders.map((header) => (
//                     <th key={header}>
//                       {header.replace(/_/g, " ").toUpperCase()}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.map((row, i) => (
//                   <tr key={i} className="text-nowrap">
//                     <td>{page * size + i + 1}</td>
//                     {manualHeaders.map((key) => (
//                       <td key={key}>
//                         {key.toLowerCase().includes("date") && row[key]
//                           ? moment(row[key], "DD-MM-YYYY", true).isValid()
//                             ? moment(row[key], "DD-MM-YYYY").format("DD-MM-YYYY")
//                             : row[key]
//                           : formatNumber(row[key])}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>

//           <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
//             <Button
//               color="outline-primary"
//               size="sm"
//               disabled={page === 0 || loading}
//               onClick={() => fetchDisbursalReport(page - 1, true)}
//               style={fontStyle}
//             >
//               Previous
//             </Button>
//             <span className="fw-bold">Page {page + 1}</span>
//             <Button
//               color="outline-primary"
//               size="sm"
//               disabled={!hasNextPage || loading}
//               onClick={() => fetchDisbursalReport(page + 1, true)}
//               style={fontStyle}
//             >
//               Next
//             </Button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default DisbursalReporting;

import React, { useEffect, useState } from "react";
import { Table, Spinner, Button, Input, Form, FormGroup, Label, Alert } from "reactstrap";
import axiosInstance from "../../Request";
import moment from "moment";
import { URL } from "../../api";

const DisbursalReporting = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [filterType, setFilterType] = useState("customerId");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // ✅ Fintech states
  const [fintechList, setFintechList] = useState([]);
  const [selectedFintechId, setSelectedFintechId] = useState("");

  const [page, setPage] = useState(0);
  const [size] = useState(30);
  const [hasNextPage, setHasNextPage] = useState(false);

  const manualHeaders = [
    "customer_id", "lead_id", "loan_id", "borrower_name", "fintech_name",
    "loan_amount", "roi", "tenure", "processing_fee", "gst", "disbursal_amt",
    "repayment_type", "roi_type_value", "disbursal_date", "close_date",
    "create_date", "disbursal_utr"
  ];

  // ✅ Fintech list fetch - same as LoanReporting
  useEffect(() => {
    const fetchFintechs = async () => {
      try {
        const res = await axiosInstance.get(URL.LSP_LIST);
        setFintechList((res.data || []).filter((f) => f.isActive));
      } catch (err) {
        console.error("Failed to fetch fintech list:", err);
      }
    };
    fetchFintechs();
  }, []);

  const fetchDisbursalReport = async (pageNo = 0, isSearch = false) => {
    setLoading(true);
    try {
      const filters = {};
      if (filterValue) filters[filterType] = filterValue;
      if (fromDate) filters.fromDate = fromDate;
      if (toDate) filters.toDate = toDate;
      if (selectedFintechId) filters.fintechId = selectedFintechId; // ✅

      if (!isSearch && !filterValue && !fromDate && !toDate) {
        const today = moment().format("YYYY-MM-DD");
        filters.fromDate = today;
        filters.toDate = today;
      }

      const params = { ...filters, page: pageNo, size: size, export: false };

      const response = await axiosInstance.get(URL.REPORTING_DISBURSAL, { params });
      const data = response.data || [];

      setRows(data);
      setPage(pageNo);
      setHasNextPage(data.length === size);
    } catch (error) {
      console.error("Error fetching Disbursal data:", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDisbursalReport(0, false);
  }, []);

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    fetchDisbursalReport(0, true);
  };

  const handleExportCsv = async () => {
    setExporting(true);
    try {
      const filters = {};
      if (filterValue) filters[filterType] = filterValue;
      if (fromDate) filters.fromDate = fromDate;
      if (toDate) filters.toDate = toDate;
      if (selectedFintechId) filters.fintechId = selectedFintechId; // ✅

      const response = await axiosInstance.get(URL.REPORTING_DISBURSAL, {
        params: { ...filters, export: true },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Disbursal_Report_${moment().format("YYYY-MM-DD")}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Export failed!");
    } finally {
      setExporting(false);
    }
  };

  const fontStyle = { fontSize: "10px" };
  const inputStyle = { ...fontStyle, height: "30px", padding: "2px 6px" };

  const formatNumber = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    if (typeof val === "number" || !isNaN(val)) {
      const num = parseFloat(val);
      return num % 1 === 0 ? num : num.toFixed(2);
    }
    return val;
  };

  return (
    <div className="p-3" style={fontStyle}>
      <Form onSubmit={handleSearch} className="mb-3">
        <div className="d-flex flex-wrap align-items-end" style={{ gap: "10px" }}>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Filter Type</Label>
            <Input type="select" value={filterType} onChange={(e) => setFilterType(e.target.value)} style={inputStyle}>
              <option value="customerId">Customer ID</option>
              <option value="loanId">Loan ID</option>
              <option value="leadId">Lead ID</option>
            </Input>
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Filter Value</Label>
            <Input
              type="text"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              placeholder={`Enter ${filterType}`}
              style={inputStyle}
            />
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">From Date</Label>
            <Input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputStyle} />
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">To Date</Label>
            <Input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputStyle} />
          </FormGroup>

          {/* ✅ Fintech Dropdown - same as LoanReporting */}
          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Fintech</Label>
            <Input
              type="select"
              value={selectedFintechId}
              onChange={(e) => setSelectedFintechId(e.target.value)}
              style={{ ...inputStyle, width: 160 }}
            >
              <option value="">All Fintechs</option>
              {fintechList.map((f) => (
                <option key={f.id} value={f.id}>
                  {f.brandName || f.name}
                </option>
              ))}
            </Input>
          </FormGroup>

          <div className="d-flex" style={{ gap: "6px" }}>
            <Button color="primary" type="submit" disabled={loading} style={{ ...fontStyle, height: "30px" }}>
              {loading ? <Spinner size="sm" /> : "Search"}
            </Button>
            <Button color="success" onClick={handleExportCsv} disabled={exporting || rows.length === 0} style={{ ...fontStyle, height: "30px" }}>
              {exporting ? <Spinner size="sm" /> : "Excel"}
            </Button>
          </div>
        </div>
      </Form>

      {/* Table same as before - no changes needed */}
      {rows.length === 0 && !loading ? (
        <Alert color="info">No records found for the selected criteria.</Alert>
      ) : (
        <>
          <div style={{ overflowX: "auto" }}>
            <Table bordered striped hover responsive size="sm" className="mt-2" style={fontStyle}>
              <thead className="table-light">
                <tr className="text-nowrap">
                  <th>#</th>
                  {manualHeaders.map((header) => (
                    <th key={header}>{header.replace(/_/g, " ").toUpperCase()}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i} className="text-nowrap">
                    <td>{page * size + i + 1}</td>
                    {manualHeaders.map((key) => (
                      <td key={key}>
                        {key.toLowerCase().includes("date") && row[key]
                          ? moment(row[key], "DD-MM-YYYY", true).isValid()
                            ? moment(row[key], "DD-MM-YYYY").format("DD-MM-YYYY")
                            : row[key]
                          : formatNumber(row[key])}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
            <Button color="outline-primary" size="sm" disabled={page === 0 || loading} onClick={() => fetchDisbursalReport(page - 1, true)} style={fontStyle}>Previous</Button>
            <span className="fw-bold">Page {page + 1}</span>
            <Button color="outline-primary" size="sm" disabled={!hasNextPage || loading} onClick={() => fetchDisbursalReport(page + 1, true)} style={fontStyle}>Next</Button>
          </div>
        </>
      )}
    </div>
  );
};

export default DisbursalReporting;